import PropTypes from "prop-types";
import { Box, Typography } from "@material-ui/core";
import CommentItem from "../comment-item";

const CommentThread = ({ comments = [], onRetry }) => {
  if (!comments || comments.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography sx={{ color: "#6b778c", fontSize: 14 }}>
          No comments yet
        </Typography>
      </Box>
    );
  }

  return (
    <Box>
      {comments.map((comment) => (
        <CommentItem key={comment.id} comment={comment} onRetry={onRetry} />
      ))}
    </Box>
  );
};

CommentThread.propTypes = {
  comments: PropTypes.array,
  onRetry: PropTypes.func,
};

export default CommentThread;
